import { SystemOptionType } from 'data/types';

export function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

export function numericOrZero(value: unknown): number {
  return isFiniteNumber(value) ? value : 0;
}

export function sumCondenserAmperage(
  condensers: Array<{ selectedProduct?: { amperage?: number | null } }>
): number {
  return condensers.reduce(
    (acc, cond) => acc + numericOrZero(cond.selectedProduct?.amperage),
    0
  );
}

export function sanitizeSystemOptionForPersist(
  option: SystemOptionType
): SystemOptionType {
  const condensers = option.configuration.condensers
    .filter((cond) => cond.selectedProduct)
    .map((cond) => ({
      ...cond,
      zones: cond.zones.filter((zone) => zone.selectedProduct)
    }))
    .filter((cond) => cond.zones.length > 0);

  return {
    ...option,
    amperage: isFiniteNumber(option.amperage)
      ? option.amperage
      : sumCondenserAmperage(condensers),
    numberOfCondensers: condensers.length,
    numberOfZones: condensers.reduce(
      (total, cond) => total + cond.zones.length,
      0
    ),
    configuration: {
      ...option.configuration,
      condensers
    }
  };
}

export function sanitizeSystemsToCompare(
  systems: SystemOptionType[]
): SystemOptionType[] {
  return systems.map(sanitizeSystemOptionForPersist);
}
